import { createContext, useContext } from 'react'

export type FormDataContextType = {
	// first name
	firstName: string
	setFirstName: (c: string) => void
	// last name
	lastName: string
	setLastName: (c: string) => void
	// email
	email: string
	setEmail: (c: string) => void
	// phone number
	phone: string
	setPhone: (c: string) => void
	// service address
	address: string
	setAddress: (c: string) => void
	// county
	county: string
	setCounty: (c: string) => void
	// job details
	jobDetails: string
	setJobDetails: (c: string) => void
	// how did you hear about us
	referralSource: string
	setReferralSource: (c: string) => void
	// referral source other
	referralSourceOther: string
	setReferralSourceOther: (c: string) => void
	// may we send you offers
	subscribe: boolean
	setSubscribe: (keys: boolean) => void
	// anything else to add
	otherDetails: string
	setOtherDetails: (c: string) => void
}

export const FormDataContext = createContext<FormDataContextType>({
	// first name
	firstName: "",
	setFirstName: () => { },
	// last name
	lastName: "",
	setLastName: () => { },
	// email
	email: "",
	setEmail: () => { },
	// phone number
	phone: "",
	setPhone: () => { },
	// service address
	address: "",
	setAddress: () => { },
	// county
	county: "",
	setCounty: () => { },
	// job details
	jobDetails: "",
	setJobDetails: () => { },
	// how did you hear about us
	referralSource: "",
	setReferralSource: () => { },
	// referral source other
	referralSourceOther: "",
	setReferralSourceOther: () => { },
	// may we send you offers
	subscribe: true,
	setSubscribe: () => { },
	// anything else to add
	otherDetails: "",
	setOtherDetails: () => { },
})

export const useFormDataContext = () => useContext(FormDataContext)
